import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import {
  CALL_STATE_IDENTIFIER,
  CALL_STATE_IDENTIFIER_SAVE,
  DETAIL_REQUEST_IDENTIFIER,
  DETAIL_REQUEST_LOADER_IDENTIFIER,
  HISTORY_REQUEST_LOADER,
  REQUEST_LIST_IDENTIFIER,
  SELECTED_REQUEST_IDENTIFIER,
  CSV_REQUEST_LIST_IDENTIFIER,
  CSV_REQUEST_LOAD_IDENTIFIER,
} from "./constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [CSV_REQUEST_LOAD_IDENTIFIER]: false,
  [CSV_REQUEST_LIST_IDENTIFIER]: [],
  [REQUEST_LIST_IDENTIFIER]: [],
  [HISTORY_REQUEST_LOADER]: false,
  [SELECTED_REQUEST_IDENTIFIER]: null,
  [DETAIL_REQUEST_IDENTIFIER]: null,
  [DETAIL_REQUEST_LOADER_IDENTIFIER]: false,
  [CALL_STATE_IDENTIFIER]: IResponseState.PENDING,
  [CALL_STATE_IDENTIFIER_SAVE]: IResponseState.PENDING,
};
